module.exports = __webpack_public_path__ + "img/lightning.6335a7cc.svg";